import { Component } from "@angular/core";
import { NavController,ModalController} from "@ionic/angular";
import { StorageProvider } from "../../providers/storage-service/storage-service";
import { Router } from "@angular/router";

@Component({
    selector: 'edit-athlete-data',
    templateUrl: 'edit-athlete-data.html',
    styleUrls:['./edit-athlete-data.scss']
})

export class EditAthleteData{

    athleteData;
    routerState:any

    constructor(private navCtrl: NavController,
            private router:Router,
            private storageService: StorageProvider,
            private viewCtrl: ModalController
        ){
        const nav = this.router.getCurrentNavigation();
        this.routerState = nav?.extras?.state || {};
        this.getData();
    }

    getData(){
        this.athleteData = this.routerState["ath"];
        console.log("athlete edit"+JSON.stringify(this.athleteData));
    }
    onBackMenu(){
    this.viewCtrl.dismiss(this.athleteData);
    // this.navCtrl.pop();
    }
}